import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '../../shared/services/toast.service';
import { InvitationService } from '../services/invitation.services';
import { invitationsActions } from './invitations.actions';
import { IConnection } from '../../connections/model/connection.model';
import { connectionsActions } from '../../connections/store/connections.actions';

@Injectable()
export class InvitationsEffects {
  constructor(private actions$: Actions,
      private invitationsService: InvitationService,
      private toastService: ToastService,
      private translate: TranslateService) {}

  requestInvitationEffect$ = createEffect(() => this.actions$.pipe(
      ofType(invitationsActions.requestInvitation),
      switchMap((action) =>
        this.invitationsService.sendInvitation(action.invitation).pipe(
          map(invitation => {
            if (invitation.isInvitation) {
              this.toastService.Success(this.translate.instant("invitation.invite.sent"), '');
              return invitationsActions.requestInvitationSentSuccess({invitation})
            } else {
              const connection = {
                id: invitation.id,
                login: invitation.login,
                userId: invitation.userId
              } as IConnection;
              this.toastService.Success(this.translate.instant("connection.invite.sent"), '');
              return connectionsActions.requestConnectionSentSuccess({connection})
            }
          }),
          catchError(() => {
              this.toastService.Error(this.translate.instant("connection.invite.error"), '');
              return of(invitationsActions.requestInvitationSentFailure({ error: 'Invalid credentials' }))
            }
          )
        )
      )
    )
  );

  cancelRequestInvitationEffect$ = createEffect(() => this.actions$.pipe(
      ofType(invitationsActions.cancelRequestInvitation),
      switchMap((action) =>
        this.invitationsService.cancelInvitation(action.invitationId).pipe(
          map(invitation => {
            this.toastService.Success(this.translate.instant("invitation.invite.cancelled"), '');
            return invitationsActions.cancelRequestInvitationSentSuccess({invitation})
          }),
          catchError(() => of(invitationsActions.cancelRequestInvitationSentFailure({ error: 'Error cancelling invitation' })))
        )
      )
    )
  );

  getPendingRequestsEffect$ = createEffect(() => this.actions$.pipe(
    ofType(invitationsActions.getPendingRequests),
    switchMap(() =>
      this.invitationsService.getInvitations().pipe(
        map(invitations => invitationsActions.getPendingRequestsSuccess({invitations}))
      )
    )
  ));
}
